import { skipToken } from '@reduxjs/toolkit/query';

import { useAppSelector } from 'store';
import { useGetPayerDetailsQuery } from 'store/api/referenceApi';

/* Payer specific feature flags */
export const PayerFeatures = {
    APREFERRAL: 'APREFERRAL',
    MEDBILLING: 'MEDBILLING',
    PLAN_NOTES: 'PLAN_NOTES',
    POLICY_MAN: 'POLICY_MAN',
} as const;
export type PayerFeature = (typeof PayerFeatures)[keyof typeof PayerFeatures];

export const usePayerFeatures = (payerId?: string) => {
    const { data: payerDetails } = useGetPayerDetailsQuery(payerId ? { payerId } : skipToken);
    return payerDetails?.payerFeatures
        ? Object.fromEntries(payerDetails.payerFeatures.map((feature) => [feature, true]))
        : undefined;
};

/* Supplier specific feature flags */
export const SupplierFeatures = {
    MEDBILLING: 'MEDBILLING',
} as const;
export type SupplierFeature = (typeof SupplierFeatures)[keyof typeof SupplierFeatures];

export const useSupplierFeatures = () => {
    const supplierFeatures = useAppSelector((state) => state.auth.supplierFeatures);
    return supplierFeatures
        ? Object.fromEntries(supplierFeatures.map((feature) => [feature, true]))
        : undefined;
};
